// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"b4ad6e75c32447ff","888":"11f90e21ec039b8b"}[chunkId] + ".css";
};